import { useSelector } from "react-redux";
import RootState from "../store/state";

const useMessages = () => {
    const messages = useSelector<RootState, RootState["messages"]>(
        state => state.messages
    )

    return messages;
}

export default useMessages